<template>
    <div class="wrap">
        <meeting_head v-if="$route.meta.mobileshow"></meeting_head>
        <router-view></router-view>
        <footer_index v-if="$route.meta.mobileshow" v-show="footShow"></footer_index>
    </div>
</template>

<script>
import meeting_head from './mobile_head.vue';
import footer_index from './mobile_footer.vue';

export default {
    name: 'index',
    components: {
        meeting_head,
        footer_index,
    },
    data() {
        return {
            mtgId: '',
            footShow: true,
        };
    },
    created() {
        if (this.$route.query.mid != '') {
            this.mtgId = this.$route.query.mid;
            this.getWebSiteConfigList();
        }
    },
    methods: {
        getWebSiteConfigList() {
            let _this = this;
            this.httphelper
                .post('/api/WebSiteConfigApi/GetWebSiteConfigList', {
                    mtg_Id: parseInt(_this.mtgId),
                    type: 2,
                })
                .then(res => {
                    if (res.data.code == 200) {
                        _this.Advertlist = res.data.data.advertlist;
                        if (_this.Advertlist.length > 0 && _this.Advertlist[0].templateType == 2) this.footShow = false;
                    }
                });
        },
    },
};
</script>

<style scoped>
.wrap {
    min-height: 100%;
    display: flex;
    flex-direction: column;
}
</style>
